import { render, staticRenderFns } from "./EditRfid.vue?vue&type=template&id=38da4ab1"
import script from "./EditRfid.vue?vue&type=script&lang=js"
export * from "./EditRfid.vue?vue&type=script&lang=js"
import style0 from "./EditRfid.vue?vue&type=style&index=0&id=38da4ab1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports